import { useAction, useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CommentMessage } from '@root/entities/comment/ui'

import type { Comment } from '@root/entities/comment'
import type { CommentsModel } from '@root/features/comment/atoms'

type CommentItemBodyEditProps = {
  comment: Comment.Comment
  model: CommentsModel
}

export const CommentItemBodyEdit = ({
  comment,
  model,
}: CommentItemBodyEditProps) => {
  const [newContent, setNewContent] = useState<string>(comment.content)
  const [newImage, setNewImage] = useState<string | undefined>(
    comment.imageAttachment,
  )

  const [_, setEditCommentId] = useAtom(model.editCommentIdAtom)
  const [editCommentRequestState] = useAtom(model.editCommentRequestState)
  const editCommentAction = useAction(model.editCommentAction)

  const handleEditClose = () => setEditCommentId(undefined)
  const handleEditSave = () => {
    const deleteAttachment = !!comment.imageAttachment && newImage === undefined

    editCommentAction({
      req: {
        content: newContent,
        commentId: comment.id,
        deleteAttachment,
        imageAttachment: newImage,
      },
    })
  }

  const noChanges =
    newContent === comment.content && newImage === comment.imageAttachment

  return (
    <Root
      isLoading={AsyncStateN.isLoading(editCommentRequestState)}
      disabled={AsyncStateN.isLoading(editCommentRequestState)}
      disabledSend={noChanges}
      text={newContent}
      onChange={(value) => setNewContent(value)}
      onMessageSend={handleEditSave}
      onClose={handleEditClose}
      imageAttached={newImage}
      onImageAttachedChange={setNewImage}
    />
  )
}

const Root = styled(CommentMessage)`
  width: 100%;
`
